import {
  AvTimer,
  CalendarToday,
  CancelPresentation,
  CheckCircleOutline,
  CreditCard,
  HourglassEmpty,
  PersonAddDisabled,
  SvgIconComponent,
  TimerOff,
} from '@material-ui/icons';

export const STATE_ATTRIBUTES: Record<string, { text: string; icon: SvgIconComponent }> = {
  ATTENDED: { text: 'Attended', icon: CheckCircleOutline },
  CANCELLED: { text: 'Cancelled', icon: CancelPresentation },
  COMPLETED: { text: 'Completed', icon: CheckCircleOutline },
  COMPLETED_CREDITED: { text: 'Credited Session', icon: CreditCard },
  // the DUPLICATE state is used internally by Ops and these sessions will be deleted
  DUPLICATE: { text: 'Cancelled', icon: CancelPresentation },
  IN_PROGRESS: { text: 'In Progress', icon: AvTimer },
  LATE_CANCELLATION: { text: 'Late Cancellation', icon: TimerOff },
  NO_SHOW: { text: 'No Show', icon: PersonAddDisabled },
  PENDING_INSURANCE: { text: 'Pending Insurance', icon: HourglassEmpty },
  PENDING_PAYMENT: { text: 'Pending Payment', icon: HourglassEmpty },
  PENDING_CONFIRMATION: { text: 'Pending Confirmation', icon: HourglassEmpty },
  SCHEDULED: { text: 'Scheduled', icon: CalendarToday },
};

export const SessionStateTestID = 'SessionState.TestID';
